import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { PRACTICE, YOUTUBE_MS } from '../const';
import Board from '../COMPONENTS/Board';
import BackButton from '../COMPONENTS/BackButton';
import { HIDE, HIDDEN, SHOW, FADE, YOUTUBE } from '../../HOME/const';
import Toolbar from '../COMPONENTS/Toolbar';
import { setPracticeStep, setLevel, setStartLevel, setScore } from '../REDUX/actions';
import { requestResetStats, requestSurrender } from '../../HOME/REDUX/actions';
import Options from '../COMPONENTS/Options';
import { delay } from '../../HOME/utils';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import Leaderboard from '../COMPONENTS/Leaderboard';
import { Background } from '../COMPONENTS/Background';
import ContactButton from '../../HOME/COMPONENTS/ContactButton';

class GamePage extends Component {
  state = { options: HIDDEN };
  board = React.createRef();

  componentDidMount() {
    if (this.props.mode === PRACTICE) {
      this.props.setPracticeStep(1);
    } else {
      this.board.current.handleCompete();
    }
  }

  handleClick = e => {
    let id = e.target.id;

    if (!id) {
      id = e.target.parentElement.id;
    }

    if (id !== 'options-button' && !id.startsWith('volume-')) {
      this.hideOptions();
    }
  };

  handleOptions = e => {
    this.props.requestResetStats(false);
    this.props.requestSurrender(false);

    const op = this.state.options;

    if (op === SHOW) {
      this.hideOptions();
    } else if (op === HIDDEN) {
      this.setState({ options: SHOW });
    }
  };

  hideOptions = () => {
    if (this.state.options === SHOW) {
      this.setState({ options: FADE }, () => delay(() => this.setState({ options: HIDDEN })));
    }
  };

  render() {
    return (
      <div className="page-root">
        <div style={{ display: 'grid', height: '100%', backgroundImage: Background }} onClick={this.handleClick}>
          <Board ref={this.board} />
          {this.props.showLeaders === HIDE ? null : <Leaderboard />}
        </div>
        <Options op={this.state.options} hideOptions={this.hideOptions} />
        <Toolbar board={this.board} onClickOptions={this.handleOptions} hideOptions={this.hideOptions} />
        {this.props.showLeaders === HIDE ? (
          <>
            {this.props.mode === PRACTICE && (
              <div className="home-center-button-toolbar">
                <ContactButton size={36} service={YOUTUBE} url={YOUTUBE_MS} />
              </div>
            )}
            <BackButton board={this.board} />
            <HomeButton />
          </>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps({ ms, common }) {
  return { ...ms, ...common };
}

export default connect(
  mapStateToProps,
  { setPracticeStep, setLevel, setStartLevel, setScore, requestSurrender, requestResetStats }
)(GamePage);
